/**
 * Which sync server the new-stack project app talks to.
 *
 * The NEW (subduction) server — separate from the legacy classic-WS server
 * (`VITE_SYNC_SERVER_URL`), which this app can't reuse. Env-overridable; defaults
 * to the deployed instance.
 */

export const SUBDUCTION_RELAY = `${(
  (import.meta.env.VITE_SYNC_SUBDUCTION_URL as string | undefined) ||
    'wss://mod-sync-subduction.fly.dev'
).replace(/\/$/, '')}/subduction`

/** localStorage key: the single new-stack project (multi-project routing later). */
export const PROJECT_KEY = 'mod_newsync_workspace'
